import { jsx as _jsx } from "react/jsx-runtime";
import useVideoContext from "../../hooks/useVideoContext/useVideoContext";
import AudioLevelIndicator from "../AudioLevelIndicator/AudioLevelIndicator";
export default function LocalAudioLevelIndicator() {
    const { localTracks } = useVideoContext();
    const audioTrack = localTracks.find(track => track.kind === "audio");
    return _jsx(AudioLevelIndicator, { audioTrack: audioTrack, color: "#fff" });
}
